import { defineStore } from "pinia";
import axios from "axios";

export const useAssistantChatStore = defineStore("assistantChat", {
  state: () => ({
    key: null,
    status: null,
    name: "Assistente",
    image: null,
    color: null,
  }),

  actions: {
    reset() {
      this.key = null;
      this.status = null;
      this.name = "Assistente";
      this.image = null;
      this.color = null;
    },

    async loadChatInfo(key) {
      this.reset();
      try {
        const { data } = await axios.get(`/api/assistents/bot/${key}/chat-info`);
        if (!data.success || !data.data) {
          this.reset();
          return false;
        }
        
        this.key = key;
        this.status = data.data.status;
        this.name = data.data.name || "Assistente";
        this.image = data.data.img_ia || null;
        this.color = data.data.color || null;
        return Boolean(this.status);
      } catch (err) {
        console.error("Erro ao carregar dados do chat do assistente:", err);
        this.reset();
        return false;
      }
    },
  },
});
